import { ROLES, ROUTES } from "@/constants";

export const mainMenu = [
  {
    title: "t-menu.administration",
    icon: "bxs-dashboard",
    items: [
      {
        title: "t-menu.expenses",
        url: ROUTES.EXPENSES,
        roles: [ROLES.ADMIN, ROLES.WALLET],
      },
      {
        title: "t-menu.sells",
        url: ROUTES.SELLS,
        roles: [ROLES.ADMIN, ROLES.WALLET],
      },
      {
        title: "t-menu.unallocated-operations",
        url: ROUTES.UNALLOCATED_OPERATIONS,
        roles: [ROLES.ADMIN, ROLES.WALLET],
      },
      {
        title: "t-menu.payrolls",
        url: ROUTES.PAYROLLS,
        roles: [ROLES.ADMIN],
      },
      {
        title: "t-menu.planned-expenses",
        url: ROUTES.PLANNED_EXPENSES,
        roles: [ROLES.ADMIN, ROLES.ADMINISTRATIVE_EMPLOYEE],
      },
      {
        title: "t-menu.update-data",
        url: ROUTES.UPDATE_DATA,
        roles: [ROLES.ADMIN],
      },
      {
        title: "t-menu.production-calendar",
        url: ROUTES.PRODUCTION_CALENDAR,
        roles: [ROLES.ADMIN],
      },
      {
        title: "t-menu.clients",
        url: ROUTES.CLIENTS,
        roles: [ROLES.ADMIN, ROLES.GPM, ROLES.PROJECT_MANAGER],
      },
      {
        title: "t-menu.users",
        url: ROUTES.USERS,
        roles: [ROLES.ADMIN],
      },
      {
        title: "t-menu.contracts",
        url: ROUTES.CONTRACTS,
        roles: [ROLES.ADMIN, ROLES.GPM, ROLES.PROJECT_MANAGER],
      },
    ],
  },
  {
    title: "t-menu.reports",
    icon: "bxs-dashboard",
    items: [
      {
        title: "t-menu.report-margin",
        url: ROUTES.MARGIN,
        roles: [ROLES.ADMIN, ROLES.GPM, ROLES.PROJECT_MANAGER],
      },
      {
        title: "t-menu.report-margin-archive",
        url: ROUTES.MARGIN_ARCHIVE,
        roles: [ROLES.ADMIN, ROLES.GPM, ROLES.PROJECT_MANAGER],
      },
      {
        title: "t-menu.report-margin-partner",
        url: ROUTES.MARGIN_PARTNER,
        roles: [ROLES.ADMIN],
      },
      {
        title: "t-menu.report-margin-product",
        url: ROUTES.MARGIN_PRODUCT,
        roles: [ROLES.ADMIN, ROLES.GPM, ROLES.PROJECT_MANAGER],
      },
      {
        title: "t-menu.report-wallets-balances",
        url: ROUTES.REPORT_WALLETS_BALANCES,
        roles: [ROLES.ADMIN, ROLES.WALLET],
      },
      {
        title: "t-menu.report-company-profit",
        url: ROUTES.REPORT_COMPANY_PROFIT,
        roles: [ROLES.ADMIN],
      },
      {
        title: "t-menu.report-employees",
        url: ROUTES.REPORT_EMPLOYEES,
        roles: [ROLES.ADMIN],
      },
      {
        title: "t-menu.report-efficiency",
        url: ROUTES.EFFICIENCY,
        roles: [ROLES.ADMIN, ROLES.HEAD],
      },
    ],
  },
];

export function collectUserRoles(user) {
  const roles = [];
  if (user?.userRole) roles.push(user.userRole);
  if (user?.countWallets > 0) roles.push(ROLES.WALLET);
  if (user?.isHeadOfDepartment) roles.push(ROLES.HEAD);
  return roles;
}

export function getMenu(user) {
  const roles = collectUserRoles(user);

  const menu = [];
  let menuRow;

  for (let row of mainMenu) {
    menuRow = Object.assign({}, row);
    let menuItems = [];

    for (let item of menuRow.items) {
      let accepted = false;
      roles.forEach((role) => (accepted = accepted || item.roles.includes(role)));

      if (accepted) {
        menuItems.push(item);
      }
    }

    if (!menuItems.length) {
      continue;
    }

    menuRow.items = menuItems;
    menu.push(menuRow);
  }
  return menu;
}
